import api from "./api";

async function getUser(userId: string) {
  return await api.get("/api/userInfo", {
    params: { id: userId },
  });
}

async function getQuote(userId: string, quoteNumber: number) {
  return await api.get("/api/history/getSummaryQuote", {
    params: {
      userId,
      quoteNumber,
    },
  });
}

async function postPO(quoteId: string, poNumber: string) {
  return await api.put("/api/editPO", {
    quoteId,
    poNumber,
  });
}

async function postSummaryData(quoteArg: {
  quoteId: string,
  margin: string,
  withMarkup: boolean
}) {
  return await api.put("/api/editOrderSummary", quoteArg);
}

async function postCustomSalesTax(salesTax: number, quoteId: string) {
  return await api.put("/api/customSalesTax", {
    salesTax,
    quoteId,
  });
}

async function postAdminCharge(adminArg: {
  adminCharge: number;
  adminChargeLabel: string;
  withMargin: boolean;
  quoteId: string;
  userId: string;
}) {
  return await api.put("/api/addAdminCharge", adminArg);
}

async function postToggle(bool: boolean, quoteId: string) {
  return await api.put(`/api/overrideFixedMargin`, {
    overrideFixedMargin: bool,
    quoteId,
  });
}

async function postToggleMarkup(bool: boolean, quoteId: string) {
  return await api.put(`/api/overrideFixedMarkup`, {
    overrideFixedMarkup: bool,
    quoteId,
  });
}

async function postHideCustomer(val: string, quoteId: string) {
  return await api.put(`/api/hideCustomerPricing`, {
    hideCustomerPricing: val,
    quoteId,
  });
}

async function postSeriesOverride(val: string, quoteId: string) {
  return await api.put(`/api/seriesOverride`, {
    seriesOverride: val,
    quoteId,
  });
}

interface Jobsite {
  contactName: string;
  contactNumber: string;
  city: string;
  zip: string;
  address: string;
}

async function postJobsiteDetails(jobsiteArg: {
  id: string;
  jobsite: Jobsite;
  chosenTax: string | null;
  currentTax: number;
}) {
  return await api.put(`/api/jobsiteDetails`, jobsiteArg);
}

async function postAddCost(addCostArg: {
  quoteId: string;
  addCostName: string;
  addCostAmount: number;
  taxable: boolean;
  margin: string;
  withMarkup: boolean;
}) {
  return await api.post(`/api/addCost`, addCostArg);
}

async function updateAddCost(addCostArg: {
  quoteId: string;
  costId: string;
  addCostName: string;
  addCostAmount: number;
  taxable: boolean;
  margin: string;
  withMarkup: boolean;
}) {
  return await api.post(`/api/updateAddCost`, addCostArg);
}

async function deleteAddCost(addCostArg: {
  quoteId: string;
  costId: string;
  margin: string;
  withMarkup: boolean;
}) {
  return await api.post(`/api/deleteAddCost`, addCostArg);
}

async function getFreightQuote(quoteNumber: number, options = {}) {
  return await api.post("/api/freightQuote", { quoteNumber }, options);
}

async function updateCustomCladColorPrice(quoteId: string, customCladColorPrice: number) {
  return await api.put("/api/updateCustomCladColorPrice", {
    quoteId,
    customCladColorPrice,
  });
}

async function updateFreightQuotePrice(quoteId: string, freightQuotePrice: number) {
  return await api.put("/api/updateFreightQuotePrice", {
    quoteId,
    freightQuotePrice,
  });
}

export {
  deleteAddCost,
  updateAddCost,
  postAddCost,
  postJobsiteDetails,
  postSummaryData,
  postPO,
  getQuote,
  getUser,
  postCustomSalesTax,
  postAdminCharge,
  postToggle,
  postHideCustomer,
  postToggleMarkup,
  postSeriesOverride,
  getFreightQuote,
  updateCustomCladColorPrice,
  updateFreightQuotePrice
};
